// Components
import { NavLink, useLocation } from 'react-router-dom';
import { AppBar, Toolbar } from '@mui/material';
import { ButtonCustom, SelectCustom, TextCustom } from '../../atoms';
import { MobileMenu } from '../../organisms';
import { DropMenuOptions } from '../../molecules';

// Assets
import menuHamburger from '../../../assets/icons/menu-hamburger.svg';

//hooks
import { useApp } from '../../../hooks/others';
import {
  handelCloseMenu,
  handleMouseIn,
  handleMouseOut,
  handleOpenMenu,
  LOGO_HEADER,
  MOSTRAR_MENU_WEB,
  PAISES_ASEGURAME,
} from './utils';
import { DEFAULT_URL } from '../../../utils';

const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

const HeaderMenu = () => {
  return (
    <AppBar
      position="fixed"
      elevation={2}
      sx={{
        backgroundColor: 'var(--color-contrast-content)',
        boxShadow: '0px 2px 5px var(--color-shadow)',
      }}
    >
      <Toolbar className="bg-sombra-header">
        <MobileMenu handelCloseMenu={handelCloseMenu} />

        <div className="w-full">
          <div className="nav-padding contenedor-logo my-6 lg:my-0 ">
            <LogoHeader />

            <MenuWeb />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

function LogoHeader() {
  return (
    <>
      <NavLink to='/' onMouseEnter={handleMouseOut}>
        <img
          src={LOGO_HEADER[whiteLabel].logo}
          alt="avatar"
          className={LOGO_HEADER[whiteLabel].className}
        />
      </NavLink>

      <div className="block lg:hidden">
        <img
          src={menuHamburger}
          alt="Menu hamburguesa"
          onClick={handleOpenMenu}
        />
      </div>
    </>
  );
}

function MenuWeb() {
  const { pathname } = useLocation();

  return (
    <div className="v-web items-center ">
      <div className="flex items-center gap-8 h-16">
        <div onMouseOver={handleMouseIn}>
          <TextCustom
            text="Seguros"
            className={`menu-despegable-show text-sm enlace-header fontPRegular cursor-pointer text-black`}
          />
        </div>
        <div
          className="menu-despegable w-[90%]  mx-auto text-4xl p-4 pt-2 text-secondary-content mt-5 xl:w-[80%] 2xl:w-[95%] bg-white"
          onMouseLeave={handleMouseOut}
        >
          <div onMouseLeave={handleMouseOut}>
            <DropMenuOptions />
          </div>
        </div>

        {MOSTRAR_MENU_WEB[whiteLabel] && (
          <>
            <NavLink to="/conocenos" onMouseEnter={handleMouseOut}>
              <TextCustom
                text="Conócenos"
                className={`enlace-header text-sm fontPRegular menu-despegable-show cursor-pointer  text-black ${
                  pathname === '/conocenos' && 'font-bold'
                }`}
              />
            </NavLink>

            <NavLink to="/blog" onMouseEnter={handleMouseOut}>
              <TextCustom
                text="Blog"
                className={`text-sm enlace-header fontPRegular cursor-pointer text-black ${
                  pathname === '/blog' && 'font-bold'
                }`}
              />
            </NavLink>
          </>
        )}

        <NavLink to="/cotizar" onMouseEnter={handleMouseOut}>
          <ButtonCustom
            text="Cotizar"
            className="text-sm mt-1"
            height="auto"
            width="142px"
          />
        </NavLink>

        <>
          {MOSTRAR_MENU_WEB[whiteLabel] && (
            <div className="select-pais-nav" onMouseEnter={handleMouseOut}>
              <SelectPais />
            </div>
          )}
          <NavLink
            to="/preguntas-frecuentes"
            className="faq color-secondary p-1 w-9 h-9 text-center rounded-full borde-fq mt-1"
            onMouseEnter={handleMouseOut}
          >
            <TextCustom
              text="?"
              className="p color-secondary text-center font-bold text-base fontPRegular "
            />
          </NavLink>
        </>
      </div>
    </div>
  );
}

function SelectPais() {
  const { regionSelect, setRegionSelect } = useApp();
  return (
    <SelectCustom
      borderStyle={true}
      className="max-w-[110px] "
      radiusBorder={2}
      value={regionSelect ? regionSelect : 'CR'}
      setValue={setRegionSelect}
      defaultValue="CR"
      options={PAISES_ASEGURAME}
      onlyIconOrLabel={'icon'}
      altura={'h-10'}
      overflow="hidden"
    />
  );
}

export default HeaderMenu;
